import { Configuration } from "./Configuration";

export class ConfigurationSecurity {
    installationName: string;
    configuration: Configuration;

    constructor() {}

    public parse(obj: any) {
        if (obj.Configuration) {
            this.configuration = new Configuration();
            this.configuration.parse(obj.Configuration);
        }
        if (obj.InstallationName != null || obj.InstallationName != undefined) this.installationName = obj.InstallationName;
    }
}
